<template>
    <v-card :color="backgroundColor"
            height="325"
            :style="enabledModel ? 'border-left: 5px solid #070' : 'border-left: 5px solid grey'">

        <v-card-text>

            <div>
                <extra-filter-box v-model="models.password_request_not_sent"
                                  text="Panelists without password"
                                  description="Create password email -has not yet been sent"
                                  icon="mdi-email-off"
                                  @input="emit"
                ></extra-filter-box>

                <extra-filter-box v-model="models.password_request_sent"
                                  text="Panelists without password"
                                  description="Create password email -has been sent"
                                  icon="mdi-email"
                                  @input="emit"

                ></extra-filter-box>

                <extra-filter-box v-model="models.third_party_auth"
                                  text="Panelists using third party authentication"
                                  description="Filter and find panelists using third party authentication"
                                  icon="mdi-lock"
                                  @input="emit"
                ></extra-filter-box>
            </div>

        </v-card-text>

    </v-card>

</template>

<script>

import Json from 'vue-json-pretty';
import Store from "../../ProjectManager/store";
import Avatar from "../../../components/UI/Avatar";
import ExtraFilterBox from "./ExtraFilterBox";

export default {

    components: {
        ExtraFilterBox,
        Avatar,
        Json
    },

    props: {
        extras: {
            type: Array,
            required: true,
            default: false,
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'grey darken-2'
        }
    },

    data() {
        return {
            models: {
                password_request_not_sent: false,
                password_request_sent: false,
                third_party_auth: false,
            }
        }
    },

    computed: {
        enabledModel() {
            if (this.extras.includes('password_request_not_sent')) return true;
            if (this.extras.includes('password_request_sent')) return true;
            if (this.extras.includes('third_party_auth')) return true;
        }
    },

    methods: {
        emit() {

            const extras = Object.entries(this.models).filter(item => item[1]).map(item => item[0]);

            const data = {
                extras: extras
            };

            this.$emit('change', data);
        }
    },

    created() {
        if (!this.$store.state.ProjectManager) {
            this.$store.registerModule('ProjectManager', Store);
        }
    },
}
</script>
